import { useId } from 'react'
import { useThemePreference } from '@/contexts/themePreference'
import type { ThemePreference } from '@/theme/preference'

const CHOICES: readonly ThemePreference[] = ['light', 'dark', 'system']

/** Native radios provide Tab, arrows and Space on desktop and touch browsers. */
export function Appearance() {
  const id = useId()
  const { preference, setPreference, storageAvailable } = useThemePreference()
  return (
    <fieldset className="mt-3 border-t border-ui-hairline pt-3">
      <legend className="font-sans text-label font-medium text-ui-text">
        Appearance
      </legend>
      <div className="mt-2 flex gap-1">
        {CHOICES.map((choice) => (
          <label
            key={choice}
            className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-1 rounded-md border border-ui-boundary px-1 text-label text-ui-text has-[:checked]:border-ui-now has-[:checked]:bg-ui-raised has-[:focus]:outline-2 has-[:focus]:outline-offset-2 has-[:focus]:outline-ui-now forced-colors:border-[ButtonText]"
          >
            <input
              type="radio"
              name={id}
              value={choice}
              checked={preference === choice}
              onChange={() => setPreference(choice)}
              className="accent-ui-now"
              aria-describedby={`${id}-help`}
            />
            {choice[0].toUpperCase() + choice.slice(1)}
          </label>
        ))}
      </div>
      <p
        id={`${id}-help`}
        className="mt-2 font-sans text-label text-ui-text-muted"
      >
        System follows your device’s appearance.
      </p>
      {!storageAvailable && (
        <p
          role="status"
          className="mt-1 font-sans text-label text-ui-text-muted"
        >
          Appearance changed for this tab. Browser storage is unavailable; it
          may reset after reload.
        </p>
      )}
    </fieldset>
  )
}
